import { ConclusionKeys, FindingAreasEnum, QuestionnaireFlowType, getFindingAreaDisplayText, zodQuestionTypes } from "../surveyStatusSchemas";

const questionnaireTerminationPayments: QuestionnaireFlowType = {
    id: FindingAreasEnum.TerminationPayments,
    name: getFindingAreaDisplayText(FindingAreasEnum.TerminationPayments),
    questions: [
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q1`,
            text: "Have you made any tax-free payments to employees in the past 6 years in connection with termination of employment?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.TerminationPayments}:Q2A`,
                no: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q2A`,
            text: "Did you seek external advice regarding the income tax and NIC treatment of the payments?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.TerminationPayments}:Q3A`,
                no: `${FindingAreasEnum.TerminationPayments}:Q3B`,
            },
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q3A`,
            text: "Did you pay income tax/NIC on any payments above £30k per person?",
            type: zodQuestionTypes.enum.YesNA,
            flow: {
                yes: `${FindingAreasEnum.TerminationPayments}:Q4A`,
                na: `${FindingAreasEnum.TerminationPayments}:Q4A`,
                no: `${FindingAreasEnum.TerminationPayments}:Q4B`,
            },
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q3B`,
            text: "Were all payments made free of income tax and NIC, per person, less than £30k?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.TerminationPayments}:Q4C`,
                no: `${FindingAreasEnum.TerminationPayments}:Q4D`,
            },
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q4A`,
            text: "Was all contractual pay including holiday pay and Payments in Lieu of Notice (PILON) subject to income tax and NIC in full via Pay As You Earn (PAYE)?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.TerminationPayments}:Q5A`,
                no: `${FindingAreasEnum.TerminationPayments}:Q5B`,
            },
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q4B`,
            text: "Was all contractual pay including holiday pay and Payments in Lieu of Notice (PILON) subject to income tax and NIC in full via Pay As You Earn (PAYE)?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.TerminationPayments}:Q5C`,
                no: `${FindingAreasEnum.TerminationPayments}:Q5D`,
            },
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q4C`,
            text: "Was all contractual pay including holiday pay and Payments in Lieu of Notice (PILON) subject to income tax and NIC in full via Pay As You Earn (PAYE)?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.TerminationPayments}:Q5E`,
                no: `${FindingAreasEnum.TerminationPayments}:Q5F`,
            },
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q4D`,
            text: "Was all contractual pay including holiday pay and Payments in Lieu of Notice (PILON) subject to income tax and NIC in full via Pay As You Earn (PAYE)?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.TerminationPayments}:Q5G`,
                no: `${FindingAreasEnum.TerminationPayments}:Q5H`,
            },
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q5A`,
            text: "Did you consider/calculate Post Employment Notice Pay (PENP) where relevant?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Green,
                no: ConclusionKeys.Amber
            },
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q5B`,
            text: "Did you consider/calculate Post Employment Notice Pay (PENP) where relevant?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Amber,
                no: ConclusionKeys.Red
            },
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q5C`,
            text: "Did you consider/calculate Post Employment Notice Pay (PENP) where relevant?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.TerminationPayments}:Q5C_YES_Q6C`,
                no: `${FindingAreasEnum.TerminationPayments}:Q5C_NO_Q6C`
            },
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q5D`,
            text: "Did you consider/calculate Post Employment Notice Pay (PENP) where relevant?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.TerminationPayments}:Q6D`, //Note: Same next question for both options since it doesnt affect rating
                no: `${FindingAreasEnum.TerminationPayments}:Q6D`,
            },
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q5E`,
            text: "Did you consider/calculate Post Employment Notice Pay (PENP) where relevant?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Green,
                no: ConclusionKeys.Amber
            },
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q5F`,
            text: "Did you consider/calculate Post Employment Notice Pay (PENP) where relevant?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Amber,
                no: ConclusionKeys.Amber
            },
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q5G`,
            text: "Did you consider/calculate Post Employment Notice Pay (PENP) where relevant?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.TerminationPayments}:Q5G_YES_Q6G`,
                no: `${FindingAreasEnum.TerminationPayments}:Q5G_NO_Q6G`,
            },
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q5H`,
            text: "Did you consider/calculate Post Employment Notice Pay (PENP) where relevant?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.TerminationPayments}:Q5H_YES_Q6H`,
                no: `${FindingAreasEnum.TerminationPayments}:Q5H_NO_Q6H`
            },
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q5C_NO_Q6C`,
            text: "Did you pay Class 1A NIC on any termination payments above £30k?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Amber,
                no: ConclusionKeys.Red
            }
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q5C_YES_Q6C`,
            text: "Did you pay Class 1A NIC on any termination payments above £30k?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Amber,
                no: ConclusionKeys.Amber
            }
        },
        
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q6D`,
            text: "Did you pay Class 1A NIC on any termination payments above £30k?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Red,
                no: ConclusionKeys.Red
            }
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q5G_YES_Q6G`,
            text: "Did you pay Class 1A NIC on any termination payments above £30k?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Amber,
                no: ConclusionKeys.Amber
            }
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q5G_NO_Q6G`,
            text: "Did you pay Class 1A NIC on any termination payments above £30k?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Amber,
                no: ConclusionKeys.Amber
            }
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q5H_YES_Q6H`,
            text: "Did you pay Class 1A NIC on any termination payments above £30k?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Red,
                no: ConclusionKeys.Red
            }
        },
        {
            id: `${FindingAreasEnum.TerminationPayments}:Q5H_NO_Q6H`,
            text: "Did you pay Class 1A NIC on any termination payments above £30k?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Red,
                No: ConclusionKeys.Red
            }
        }
    ],
};

export default questionnaireTerminationPayments;